import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

export function initSentry() {
  if (!dsn) return;

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.2,
    environment: import.meta.env.MODE,
  });
}

export function setSentryUser(channelId: string, displayName?: string) {
  Sentry.setUser({
    id: channelId,
    username: displayName || channelId,
  });
}

export { Sentry };
